import React, { useState } from 'react';
import styles from '../styles/Gallery.module.css';
import Kaiya from '../components/kaiya';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

// Define an interface for our gallery images
interface GalleryImage {
    path: string;
    filename: string;
    categories: string[];
    description: string;
    credit: string; // Keep this in the interface but don't display it
}

const GalleryPage = () => {
    // Manually define images with their metadata (preserving all existing data)
    const galleryImages: GalleryImage[] = [
        {
            path: '/assets/new/BaksoLetsGo.jpg',
            filename: 'Bakso Lets Go',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoLookUp.jpg',
            filename: 'Bakso Looking Up',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoMonaLisa.jpg',
            filename: 'Bakso MonaLisa',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoOnSohni.jpg',
            filename: 'Bakso & Sohni Wrestle',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoOnSohni2.jpg',
            filename: 'Bakso & Sohni Wrestle 2',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoPoster.jpg',
            filename: 'Bakso Poster',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoSideShot.jpg',
            filename: 'Bakso Side Shot',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoSohniGhibli.jpg',
            filename: 'Bakso & Sohni Ghilbli',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoSohniGhibliBall.jpg',
            filename: 'Bakso & Sohni Ghibli 2',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoSohniGrowl.jpg',
            filename: 'Sohni Growling',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoSohniKong.jpg',
            filename: 'Bakso & Sohni Kong',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoSohniNose.jpg',
            filename: 'Bakso Boop',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoSohniOnBack.jpg',
            filename: 'Bakso & Sohni Wrestle 3',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoSohniPlayFight.jpg',
            filename: 'Bakso & Sohni Play Fight',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoSohniPlayFight2.jpg',
            filename: 'Bakso & Sohni Play Fight 2',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoSohniPlayFight3.jpg',
            filename: 'Bakso & Sohni Play Fight 3',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoSohniPlayFight4.jpg',
            filename: 'Bakso & Sohni Play Fight 4',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoSohniStare.jpg',
            filename: 'Staredown',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoStarryNight.jpg',
            filename: 'Bakso Starry Night',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoTikTokSign.jpg',
            filename: 'Bakso TikTok Sign',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/SidebySide.jpg',
            filename: 'Side by Side',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoTongueOut.jpg',
            filename: 'Bakso Stalk',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/SohniJumpBakso.jpg',
            filename: 'Sohni Jumping Over Bakso',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/SohniPatHead.jpg',
            filename: 'Head Pats',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/ArcanineBakso.jpg',
            filename: 'Arcanine Bakso',
            categories: ['aiart'],
            description: 'Adorable Bakso cub playing in his habitat at Disney\'s Animal Kingdom',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/Bakira.jpg',
            filename: 'Bakira',
            categories: ['aiart'],
            description: 'Bakso taking a peaceful nap in the shade',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/baksbob.gif',
            filename: 'Bakso Headbob',
            categories: ['bakso', 'gifs'],
            description: 'Sohni, the beautiful mother of Bakso, relaxing in her habitat',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/Baksnow.jpg',
            filename: 'Bakso Snow',
            categories: ['aiart'],
            description: 'Conrad, the majestic father of Bakso, surveying his territory',
            credit: 'TheDakGuy'
        },
        {
            path: '/assets/bakso.png',
            filename: 'Bakso',
            categories: ['bakso'],
            description: 'The complete tiger family at Disney\'s Animal Kingdom',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/BAKSO2.png',
            filename: 'Bakso',
            categories: ['bakso'],
            description: 'Bakso showing his playful personality with enrichment toys',
            credit: 'TheDakGuy'
        },
        {
            path: '/assets/bakso3.png',
            filename: 'Sleeping Bakso',
            categories: ['bakso'],
            description: 'Bakso taking a well-deserved nap after playtime',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/bakso4.png',
            filename: 'Mealtime for Bakso',
            categories: ['bakso'],
            description: 'Bakso enjoying his nutritious meal',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/bakso5.png',
            filename: 'Sleeping Bakso 2',
            categories: ['bakso'],
            description: 'Bakso\'s parents enjoying some quiet time together',
            credit: 'TheDakGuy'
        },
        {
            path: '/assets/bakso6.png',
            filename: 'Bakso Tiger Tuesday',
            categories: ['bakso'],
            description: 'The beautiful Maharaja Jungle Trek habitat at Disney\'s Animal Kingdom',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/BaksoAnime.jpg',
            filename: 'Bakso Anime Jungle',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/BaksoBDay.jpg',
            filename: 'Bakso Birthday',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/baksobobtext.gif',
            filename: 'Bakso Headbob $bakso',
            categories: ['bakso', 'gifs'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/BaksoCooking.jpg',
            filename: 'Bakso Cooking',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/BaksoDavinci.jpg',
            filename: 'Bakso Da Vinci',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/BaksoDBz.jpg',
            filename: 'Bakso DBZ',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/BaksoField.jpg',
            filename: 'Bakso Field',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/baksofwog.jpg',
            filename: 'Bakso FWOG',
            categories: ['art'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/BaksoHighRes.jpg',
            filename: 'Bakso High Res',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/BaksoIndo.jpg',
            filename: 'Bakso Indonesia',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/baksojedi2.jpg',
            filename: 'Bakso Jedi 2',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/baksolion.jpg',
            filename: 'Bakso Rock',
            categories: ['art'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/BaksoMoon.jpg',
            filename: 'Bakso Moon',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/Baksomug.jpg',
            filename: 'Bakso Tea',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/baksonobg.png',
            filename: 'Bakso No Background',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/baksooutside.jpg',
            filename: 'Bakso Big Eyes',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/Baksorocketsurf.jpg',
            filename: 'Bakso Rocket Surf',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/BaksoShinigami.jpg',
            filename: 'Bakso Shinigami',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/baksosohnidak.png',
            filename: 'Bakso and Sohni',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/BaksoThroneSleep.jpg',
            filename: 'Bakso Sleep Throne',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/BaksoViking.jpg',
            filename: 'Bakso Viking',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/bigeyedbakso.jpeg',
            filename: 'Big Eyed Bakso',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/catchthesepaws.gif',
            filename: 'Catch These Paws',
            categories: ['bakso', 'gifs'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/catchthesepaws2.gif',
            filename: 'Catch These Paws w/Text',
            categories: ['bakso', 'gifs'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/gmbakso.jpeg',
            filename: 'Bakso GM',
            categories: ['art'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/gmbaksotext.jpg',
            filename: 'Bakso GM w/Text',
            categories: ['art'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/PabloBakso.jpg',
            filename: 'Pablo Pibakso',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/Pawdawan.jpg',
            filename: 'Bakso Pawdawan',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/sleepy.png',
            filename: 'Bakso Sleepy Closeup',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/StarryBakso.jpg',
            filename: 'Starry Bakso',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/superbakso.jpg',
            filename: 'Super Bakso',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },

        {
            path: '/assets/teef.jpeg',
            filename: 'Baby Teef Bakso',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/Thisone.jpg',
            filename: 'Bakso AI',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/tigerart.jpeg',
            filename: 'Bakso PFP',
            categories: ['art'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/tigerbody.png',
            filename: 'Bakso PFP No BG',
            categories: ['art'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/TigerRaffle.jpg',
            filename: 'Bakso Raffle',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/AirBakso.jpg',
            filename: 'Air Bakso',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoAIMeadow.jpg',
            filename: 'Bakso Meadow',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoAir.jpg',
            filename: 'Bakso Air',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoAIVisit.jpg',
            filename: 'Bakso Visit',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoBaksoSign.jpg',
            filename: 'Bakso Cashtag Sign',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoBiteTag.jpg',
            filename: 'Bakso Bite',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoBobiger.jpg',
            filename: 'Bob Iger Visits Bakso',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoBowl.jpg',
            filename: 'Bakso Bowl',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoBush.jpg',
            filename: 'Bakso Bush',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoChaseSohni.jpg',
            filename: 'Bakso Chasing Sohni',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoCuteSideTag.jpg',
            filename: 'Bakso Cute Cashtag',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },

        {
            path: '/assets/new/BaksoDanco.MP4',
            filename: 'Bakso Dance',
            categories: ['aiart', 'gifs'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoGhibliSign.jpg',
            filename: 'Bakso Ghibli Cashtag',
            categories: ['aiart'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoGnaw.jpg',
            filename: 'BaksoGoo',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoGrowlAir.jpg',
            filename: 'Bakso & Sohni',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },
        {
            path: '/assets/new/BaksoLeafSohni.jpg',
            filename: 'Bakso w/Leaf',
            categories: ['bakso'],
            description: 'Disney\'s dedicated conservation team working to protect endangered species',
            credit: 'Disney Parks'
        },


    ];

    const [images] = useState<GalleryImage[]>(galleryImages);
    const [activeFilter, setActiveFilter] = useState('all');
    const [selectedImage, setSelectedImage] = useState<GalleryImage | null>(null);


    // Preserve all the existing filtering logic
    const filterImages = (category: string) => {
        setActiveFilter(category);
    };

    const openImageModal = (image: GalleryImage) => {
        setSelectedImage(image);
    };

    const closeImageModal = () => {
        setSelectedImage(null);
    };

    const getCategoryCounts = () => {
        const counts = {
            all: images.length,
            bakso: images.filter(image => image.categories.includes('bakso')).length,
            art: images.filter(image => image.categories.includes('art')).length,
            aiart: images.filter(image => image.categories.includes('aiart')).length,
            gifs: images.filter(image => image.categories.includes('gifs')).length
        };
        return counts;
    };

    const categoryCounts = getCategoryCounts();

    const isVideo = (path: string): boolean => {
        const extension = path.split('.').pop()?.toLowerCase();
        return extension === 'mp4' || extension === 'webm' || extension === 'mov';
    };

    return (
     <>
      <Navbar />
        <div className={styles.galleryPage}>
            {/* Hero Section - consistent with other pages */}
            <div className={styles.heroSection}>
                <h1>Bakso Gallery</h1>
                <p>Our favorite images of Bakso and also those made by BaksoAI</p>
            </div>

            <div className={styles.mainContent}>
                <div className={styles.gallerySection}>
                    <h2 className={styles.sectionTitle}>Gallery Collection</h2>
                    <div className={styles.tigerDivider}></div>

                    {/* Filter Buttons */}
                    <div className={styles.filterContainer}>
                        <button
                            className={activeFilter === 'all' ? styles.filterButtonActive : styles.filterButton}
                            onClick={() => filterImages('all')}
                        >
                            All Photos ({categoryCounts.all})
                        </button>
                        <button
                            className={activeFilter === 'bakso' ? styles.filterButtonActive : styles.filterButton}
                            onClick={() => filterImages('bakso')}
                        >
                            Bakso ({categoryCounts.bakso})
                        </button>
                        <button
                            className={activeFilter === 'art' ? styles.filterButtonActive : styles.filterButton}
                            onClick={() => filterImages('art')}
                        >
                            Art ({categoryCounts.art})
                        </button>
                        <button
                            className={activeFilter === 'aiart' ? styles.filterButtonActive : styles.filterButton}
                            onClick={() => filterImages('aiart')}
                        >
                            AI Art ({categoryCounts.aiart})
                        </button>
                        <button
                            className={activeFilter === 'gifs' ? styles.filterButtonActive : styles.filterButton}
                            onClick={() => filterImages('gifs')}
                        >
                            GIFs ({categoryCounts.gifs})
                        </button>
                    </div>

                    {/* Gallery Grid */}
                    <div className={styles.galleryGrid}>
                        {images
                            .filter(image => activeFilter === 'all' || image.categories.includes(activeFilter))
                            .map((image, index) => (
                                <div
                                    key={index}
                                    className={styles.galleryItem}
                                    onClick={() => openImageModal(image)}
                                >
                                    <div className={styles.imageContainer}>
                                        {isVideo(image.path) ? (
                                            <video
                                                src={image.path}
                                                className={styles.actualImage}
                                                muted
                                                loop
                                                autoPlay
                                                playsInline
                                                onMouseOver={(e) => {
                                                    const target = e.target as HTMLVideoElement;
                                                    target.play();
                                                }}
                                                onMouseOut={(e) => {
                                                    const target = e.target as HTMLVideoElement;
                                                    target.pause();
                                                }}
                                            />
                                        ) : (
                                            <img
                                                src={image.path}
                                                alt={image.filename}
                                                className={styles.actualImage}
                                                onError={(e) => {
                                                    // Fallback for missing images
                                                    const target = e.target as HTMLImageElement;
                                                    target.src = "/bakso.png";
                                                }}
                                            />
                                        )}
                                    </div>
                                    <div className={styles.imageOverlay}>
                                        <span className={styles.viewButton}>View</span>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>

            {/* Image Modal - removed photo credit */}
            {selectedImage && (
                <div className={styles.modalOverlay} onClick={closeImageModal}>
                    <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
                        <button className={styles.closeButton} onClick={closeImageModal}>×</button>
                        <div className={styles.modalImageContainer}>
                            {isVideo(selectedImage.path) ? (
                                <video
                                    src={selectedImage.path}
                                    controls
                                    autoPlay
                                    loop
                                    playsInline
                                    style={{ maxWidth: '100%', maxHeight: '100%' }}
                                    onError={(e) => {
                                        const target = e.target as HTMLVideoElement;
                                        console.error("Error loading video:", target.error);
                                    }}
                                />
                            ) : (
                                <img
                                    src={selectedImage.path}
                                    alt={selectedImage.filename}
                                    onError={(e) => {
                                        // Fallback for missing images
                                        const target = e.target as HTMLImageElement;
                                        target.src = "/bakso.png";
                                    }}
                                />
                            )}
                        </div>
                        <div className={styles.modalCaption}>
                            <h3>{selectedImage.filename}</h3>
                        </div>
                    </div>
                 
                </div>
            )}
               
        </div>
        <Footer />
        <Kaiya />
        </>
    );
};

export default GalleryPage;